import ParticipantView from './ParticipantView';

export default ParticipantView;
